import client from "../libs/HttpClient";
class TestimonialService {
  static getTestimonialData() {
    return client.get("/testimonial-list");
  }
  
}
export { TestimonialService };
